import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import IdentificationTypeService from "../../../../services/catalogs/IdentificationTypeService";

export const REQUEST_CREATE_IDENTIFICATION_TYPE =
  "REQUEST_CREATE_IDENTIFICATION_TYPE";
export const CREATE_IDENTIFICATION_TYPE_SUCCESS =
  "CREATE_IDENTIFICATION_TYPE_SUCCESS";
export const CREATE_IDENTIFICATION_TYPE_ERROR =
  "CREATE_IDENTIFICATION_TYPE_ERROR";

function requestCreateIdentificationType() {
  return {
    type: REQUEST_CREATE_IDENTIFICATION_TYPE,
  };
}

function createIdentificationTypeSuccess(json) {
  return {
    type: CREATE_IDENTIFICATION_TYPE_SUCCESS,
    message: json.data,
  };
}

function createIdentificationTypeError(json) {
  return {
    type: CREATE_IDENTIFICATION_TYPE_ERROR,
    error: json.data,
  };
}

export function createIdentificationType(payload) {
  return (dispatch) => {
    dispatch(requestCreateIdentificationType());
    return IdentificationTypeService.postIdentificationType(payload).then(
      (json) => {
        if (json.data.code === 200) {
          dispatch(createIdentificationTypeSuccess(json.data));
        } else if (json.data.code === 202) {
          updateLocalStorageToken(json.data.token);
          dispatch(createIdentificationType(payload));
        } else if (json.data.code === 498) {
          logOut();
        } else {
          dispatch(createIdentificationTypeError(json.data));
        }
      }
    );
  };
}
